import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:managePurchaseLocationList
 * @description
 * # managePurchaseLocationList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'managePurchaseLocationList',
    ($ngRedux, $rootScope, $scope, $location, $route, $http, ENV) => {
      if (!$scope.isSuperUser) {
        $location.path('/');
      }

      $scope.processParams = () =>
        new Promise((resolve) => {
          const { purchaseLocationId } = $route.current.params;
          $scope.takeAction(purchaseLocationId);
          resolve(true);
        });

      $scope.takeAction = (id) => {
        if (!id) return;

        if (id === 'create-purchase-location') {
          $scope.open(id);
        } else if (id) {
          $scope
            .getPurchaseLocation($http, ENV, id)
            .then(() => {
              $scope.open(id);
            })
            .catch(() => {
              const errorModalOptions = {
                heading: 'Purchase Location Error',
                message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
                buttons: [
                  {
                    label: 'Close',
                    href: '#',
                    clickFn: () => {
                      $rootScope.toggleErrorModal();
                      $location.path($rootScope.routes.location, false);
                    },
                  },
                ],
              };
              $rootScope.toggleErrorModal(errorModalOptions);
            });
        }
      };

      $scope.open = (id) => {
        const component =
          id === 'create-purchase-location' ? 'create-purchase-location' : 'edit-purchase-location';
        const closeRoute = $rootScope.previousRoute || $rootScope.routes.location;
        const beforeRoute = `${$rootScope.routes.location}/${id}`;
        $rootScope.openComponent({
          component: component,
          beforeRoute: beforeRoute,
          closeRoute: closeRoute,
        });
      };

      $scope.init = () => {
        $rootScope.previousRoute = $rootScope.routes.location;
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.processParams();
      };

      $scope.table = {
        name: 'Manage Purchase Locations',
        options: {
          endpoint: '/2.0/transactions/purchase-locations/',
          endpoint_data_key: 'purchase-locations',
          per_page_options: [15, 25, 50, 100, 200],
          records_per_page: 15,
          row_style: 'standard',
          scale_up: false,
          search_key: null,
          search_required: false,
        },
        actions: [
          {
            name: 'Create Purchase Location',
            link: '#',
            onclick: () => {
              $scope.takeAction('create-purchase-location');
            },
            order: 0,
            superuser: true,
          },
        ],
        columns: [
          {
            name: 'Name',
            options: {
              content: '{{ record.title }}',
              class: 'limit-width',
            },
          },
          {
            name: 'Order',
            options: {
              content: '{{ record.order || 0 }}',
              class: 'minimum-width',
            },
          },
          {
            name: 'Created',
            options: {
              content: '{{ record.created }}',
              class: '',
            },
          },
          {
            name: 'Updated',
            options: {
              content: '{{ record.updated }}',
              class: '',
            },
          },
          {
            name: 'Status',
            options: {
              content: '{{ record.is_active ? "Enabled" : "Disabled" }}',
              class: '',
            },
          },
          {
            name: 'Action',
            options: {
              content:
                '<a href="#" ng-click="takeAction(record.id)" ng-if="record.is_active === true">Edit Purchase Location</a>',
              class: 'td-action',
            },
          },
        ],
        filters: [
          {
            name: 'Purchase Location Status',
            type: 'multiple_choice',
            options: {
              choices: {
                Enabled: { state: true, value: true, order: 0 },
                Disabled: { state: true, value: false, order: 1 },
              },
              class: 'application-filter',
              query_string_parameter: 'is_active',
            },
          },
        ],
        sort_options: {
          created: {
            state: false,
            value: '-1',
            title: 'Purchase Location Created',
            order: 0,
          },
          updated: {
            state: false,
            value: '-1',
            title: 'Purchase Location Updated',
            order: 1,
          },
          order: {
            state: true,
            value: '1',
            title: 'Purchase Location Order',
            order: 2,
          },
          title: {
            state: true,
            value: '1',
            title: 'Purchase Location Name',
            order: 3,
          },
        },
      };

      $scope.init();

      $scope.$on('$destroy', $scope.unsubscribe);
    },
  );
